import React from 'react'
import { withRouter, Route, Redirect } from 'react-router-dom'

const RouteWithAuth = props => {
  if (!localStorage.getItem('token')) {
    return <Redirect to="/login" />
  }

  return <Route {...props} />
}

export default withRouter(RouteWithAuth)



// WEBPACK FOOTER //
// ./src/component/RouteWithAuth.js